<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{$route.meta.title}}
                    </div>
                    <config-write-component :configType="'policyCreate'"></config-write-component>
                    <div class="pa20 text_center">
                        <el-button type="primary" @click="save()">등록</el-button>
                        <el-button @click="$router.back()">목록</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import ConfigWriteComponent from "@/components/config/ConfigWriteComponent";
    import EventBus from "@/utils/event-bus";
    export default {
        name: 'ConfigCreate',
        mixins: [],
        components: {
            ConfigWriteComponent
        },
        props: {
        },
        data() {
            return{

            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            save() {
                EventBus.$emit('writeConfig')
            }
        },
        watch: {

        },
    }
</script>
